import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSessionContext } from "../../contexts/session-context";

export default function RequireAuth({ redirectTo = "/login" }) {
    const [session] = useSessionContext();
    const location = useLocation();

    if (session.loading) return null; // หรือใส่ loading UI ก็ได้

    if (!session.isAuthenticated) {
        return <Navigate to={redirectTo} replace state={{ from: location }} />;
    }

    return <Outlet />;
}
